/**!
 *  Conversation widget.
 *  Author: Bjorn Tollstrom <bjorn@rodolfo.se>
 */

import React from "react";
import Widget from "../../widget.js";
import "./conversation.scss";
import Fuse from "Class/Fuse";
import {RandomToken} from "Functions";
import CommentItem from "Components/UI/CommentItem";
import IconItem from "Components/UI/IconItem";
import Spinner from "Components/Feedback/Spinner";
import WidgetWrapper from "Components/UI/WidgetWrapper";

class WidgetConversation extends Widget
{
    constructor(props)
    {
        super(props);
        this.Fields = this.SetFields({
            title:
            {
                default: "Join the Conversation",
                insert: true,
                label: "Title",
                reset: true,
                type: "text",
                translate: true
            },
            community:
            {
                label: "Filter from Community",
                placeholder: "Search for community...",
                type: "content",
                types: ["community"]
            }
        }, {
            backgroundColor: "transparent",
            textColor: "black"
        }, true);
        this.LoadToken = false;
        this.Mounted = false;
        this.Name = "Conversations";
        this.Translate =
        {
            empty: "No comments",
            end: "No more comments",
            more: "Show more"
        };
        this.state =
        {
            comments: [],
            community: 0,
            done: false,
            error: false,
            loading: false,
            page: 1
        };
    }

    componentDidMount()
    {
        this.Mounted = true;
        const {content} = this.props;
        const {community} = content;
        const [C] = community || [];
        const Id = typeof C === "object" ? C[0] : C || 0;
        this.Load(Id);
    }

    componentDidUpdate()
    {
        const {content} = this.props;
        const {community: c} = this.state;
        const {community} = content;
        const [C] = community || [];
        const Id = typeof C === "object" ? C[0] : C || 0;
        if (Id !== c)
        {
            this.Load(Id);
        }
    }

    componentWillUnmount()
    {
        this.Mounted = false;
    }

    Comment = (comment) =>
    {
        const {id} = comment;
        return <CommentItem
            className="WidgetConversationComment"
            comment={comment}
            key={id}
        />;
    }

    Load = (community, reset = true) =>
    {
        const {comments, page} = this.state;
        const Endpoint = community ? `communities/${community}/buzzing` : "buzzing";
        this.setState({community, loading: true});
        const Token = this.LoadToken = RandomToken();
        let Comments = reset ? [] : comments;
        let Page = reset ? 1 : page;
        Fuse.Request(Endpoint, {page: Page}, response =>
        {
            if (!this.Mounted || Token !== this.LoadToken)
            {
                return;
            }
            const {comments, last_page} = response || {};
            if (!comments)
            {
                this.setState({
                    error: true,
                    loading: false
                });
            }
            else
            {
                comments.forEach(comment =>
                {
                    Comments.push(comment);
                });
                this.setState({
                    comments: Comments,
                    done: last_page,
                    loading: false,
                    page: Page + 1
                });
            }
        });
    }

    LoadMore = () =>
    {
        const {community, done, error, loading} = this.state;
        if (done || error || loading)
        {
            return;
        }
        this.Load(community, false);
    }

    render()
    {
        const WidgetContent = this.Content();
        const {active, hover} = this.props;
        const {comments, done, loading} = this.state;
        const CA = ["Widget", "WidgetConversation", "White", "BorderRadius"];
        const Empty = !comments || !comments.length;
        const Content = [];
        if (active)
        {
            CA.push("Active");   
        }
        if (hover)
        {
            CA.push("Hover");   
        }
        if (!comments.length && loading)
        {
            CA.push("Loading");   
            Content.push(<Spinner
                className="WidgetSpinner"
                key="spinner"
                overlay={true}
            />);
        }
        else if (Empty)
        {
            Content.push(<div   
                className="WidgetEmpty"
                key="empty"
            >{this.GetTranslation("empty")}</div>);
        }
        else
        {
            const Comments = [];
            comments.forEach(comment =>
            {
                Comments.push(this.Comment(comment));
            });
            Content.push(
                <div
                    className="WidgetConversationComments"
                    key="comments"
                >{Comments}</div>
            );
            Content.push(
                <IconItem
                    className="WidgetConversationButton"
                    disabled={done}
                    feather={done ? "StopCircle" : "PlusCircle"}
                    key="fetch"
                    label={done ? this.GetTranslation("end") : this.GetTranslation("more")}
                    loading={loading}
                    onClick={this.LoadMore}
                />
            );
        }
        return (
            <div className={CA.join(" ")} ref={widget => this.RefWidget = widget} style={this.Style()}>
                {this.Toolbar()}
                <WidgetWrapper
                    {...WidgetContent}
                    className="WidgetConversationWrapper"
                    onScrollEnd={this.LoadMore}
                >
                    {Content}
                </WidgetWrapper>
            </div>
        );
   }
}

export default WidgetConversation;